import { DataType } from '../../DataType';
import { ExprError } from '../ExprError';
import { validateArguments } from '../../SignatureValidation';
import { getResolvedType, isNullDataType, isNullLiteral, nodeResolvesToBooleanType, nodeResolvesToDateLikeType, nodeResolvesToNumericType, nodeResolvesToStringType, } from '../../Types';
export var IfNullFn;
(function (IfNullFn) {
    IfNullFn.Name = `IFNULL`;
    IfNullFn.Stage = "SCALAR";
    IfNullFn.Signature = `IFNULL(<expression>, <altExpression>)`;
    function make(callName, args, type, role) {
        return {
            name: IfNullFn.Name,
            stage: IfNullFn.Stage,
            data: { type, role },
            value(value1, value2) {
                var _a;
                if (arguments.length === 2) {
                    return ((_a = value1 !== null && value1 !== void 0 ? value1 : value2) !== null && _a !== void 0 ? _a : null);
                }
                throw new Error(`${IfNullFn.Name} function expects 2 arguments ` +
                    `but received ${arguments.length}`);
            },
        };
    }
    IfNullFn.make = make;
    function getType([t1, t2]) {
        if (isNullDataType(t1)) {
            return t2;
        }
        if (isNullDataType(t2)) {
            return t1;
        }
        switch (t1.name) {
            case "INTEGER":
            case "DECIMAL":
            case "FLOAT": {
                return ([t1, t2].find((type) => type.name === "DECIMAL") ||
                    [t1, t2].find((type) => type.name === "FLOAT") ||
                    t1);
            }
            case "TIMESTAMP":
            case "DATE_TIME": {
                return DataType.TimestampType.make();
            }
            default: {
                return t1;
            }
        }
    }
    IfNullFn.getType = getType;
    function validate(callNode, callName, args) {
        return validateArguments({
            meta: {
                name: IfNullFn.Name,
                signature: IfNullFn.Signature,
                location: callNode.location,
            },
            arguments: [
                {
                    stages: [
                        "CONST",
                        "SCALAR",
                        "AGGREGATE",
                        "ANALYTIC",
                    ],
                },
                {
                    customValidation(replacementNode) {
                        const checkNode = args[0];
                        if (isNullLiteral(checkNode) || isNullLiteral(replacementNode)) {
                            return [];
                        }
                        let typeMismatch = false;
                        if (nodeResolvesToNumericType(checkNode) &&
                            !nodeResolvesToNumericType(replacementNode)) {
                            typeMismatch = true;
                        }
                        else if (nodeResolvesToStringType(checkNode) &&
                            !nodeResolvesToStringType(replacementNode)) {
                            typeMismatch = true;
                        }
                        else if (nodeResolvesToDateLikeType(checkNode) &&
                            !nodeResolvesToDateLikeType(replacementNode)) {
                            typeMismatch = true;
                        }
                        else if (nodeResolvesToBooleanType(checkNode) &&
                            !nodeResolvesToBooleanType(replacementNode)) {
                            typeMismatch = true;
                        }
                        if (typeMismatch) {
                            const t1 = getResolvedType(checkNode);
                            const t2 = getResolvedType(replacementNode);
                            return [
                                new ExprError.InvalidArgument(IfNullFn.Name, null, `${IfNullFn.Signature} function expected input of (${t1}, ${t1}) ` +
                                    `but received (${t1}, ${t2})`, callNode.location),
                            ];
                        }
                        return [];
                    },
                },
            ],
        }, args);
    }
    IfNullFn.validate = validate;
})(IfNullFn || (IfNullFn = {}));
